import "./BlogPreview.css";
import { BlogPreviewSingle, Social, Footer, Ctabanner, Nav } from "../../Components/ExportComponents";
import author from "../../Images/Brand/Author.png";
import { useState } from "react";
const BlogPreview = () => {
    const [menuBar, setMenuBar] = useState(false);
    return (
        <>
            <div className="backgroundBig">
        <span className="mainBackgroundHR"></span>
        <span className="mainBackgroundHRleft"></span>
        <div className="mainBackgroundHRRight"></div>
        <span className="mainBackgroundHRright"></span>
        <span className="mainBackgroundBig"></span>
        <span className="mainBackgroundBigRight"></span>

        <div className="smallBack">
          <div className="topLeftInternal"></div>
          <div className="topLeftInternal2"></div>

          <div className="topRightInternal"></div>
          <div className="topRightInternal2"></div>
                    <Nav setMenuBar={setMenuBar} menuBar={menuBar} />
                    <div className="blogPreview">
                        <div className="blogBb ">
                            <div className="titleNdecsFr">
                                <div className="titleHeadline">
                                    Blog
                                </div>
                                <div className="titleDesc">
                                    covering creativity, strategy, and the business side of design, strategy, marketing
                                </div>
                            </div>
                            <div className="titleOfBlogP">
                                A collection of experience-backed content that breaks down design principles, brand strategy, digital trends, and creative workflows
                            </div>
                            <div className="uProfile">
                                <div className="left">
                                    <img src={author} alt="" />
                                </div>
                                <div className="right">
                                    <div className="name">Bhanubhakta_Sapkota</div>
                                    <div className="post">Graphic Designer</div>
                                </div>
                            </div>
                        </div>

                        <div className="listBlogPreview">
                            <BlogPreviewSingle />

                            <BlogPreviewSingle />
                        </div>
                    </div>
                    <Ctabanner />
                </div>

                <Social />
                <Footer />
            </div>
        </>
    )
}
export default BlogPreview;